import classNames from 'classnames'

export default function ParkCardBadge({ park }) {
  if (!park.badge && !park.multipleBadge) return null

  let bgClass = park.isReservationApproved ? 'bg-primary' : 'bg-secondary'

  return (
    <div className="badge-container">
      {park.badge &&
        <div className={classNames('badge', bgClass)}>
          {park.badge}
        </div>
      }

      {park.multipleBadge &&
        <div className="badge text-nowrap" style={{ backgroundColor: 'transparent', color: 'inherit', paddingLeft: 0, paddingRight: 0 }}>
          {park.multipleBadge}
        </div>
      }
    </div>
  )
}
